module.exports = __webpack_public_path__ + "img/Mali.d9efe38d.png";